import { createGlobalStyle } from 'styled-components';

import colors from './styles/colors';
import typography from './styles/typography';

export default createGlobalStyle`
  /* globally scoping under :root is too risky for consumers, especially app shell ones, which is why we use the scoping class */
  /* the alloy namespace on each variable is used to better future proof and differentiate them as well as help with completion */
  .alloy-scope {
    --alloy-black: ${colors.black};
    --alloy-white: ${colors.white};
    --alloy-adsk-blue-100: ${colors.adskBlue100};
    --alloy-adsk-blue-300: ${colors.adskBlue300};
    --alloy-adsk-blue-500: ${colors.adskBlue500};
    --alloy-adsk-blue-600: ${colors.adskBlue600};
    --alloy-adsk-blue-700: ${colors.adskBlue700};
    --alloy-charcoal-050: ${colors.charcoal050};
    --alloy-charcoal-100: ${colors.charcoal100};
    --alloy-charcoal-200: ${colors.charcoal200};
    --alloy-charcoal-300: ${colors.charcoal300};
    --alloy-charcoal-400: ${colors.charcoal400};
    --alloy-charcoal-500: ${colors.charcoal500};
    --alloy-charcoal-600: ${colors.charcoal600};
    --alloy-charcoal-700: ${colors.charcoal700};
    --alloy-charcoal-800: ${colors.charcoal800};
    --alloy-charcoal-900: ${colors.charcoal900};
    --alloy-red-100: ${colors.red100};
    --alloy-red-300: ${colors.red300};
    --alloy-red-500: ${colors.red500};
    --alloy-red-600: ${colors.red600};
    --alloy-red-700: ${colors.red700};
    --alloy-pink-300: ${colors.pink300};
    --alloy-pink-500: ${colors.pink500};
    --alloy-pink-700: ${colors.pink700};
    --alloy-purple-300: ${colors.purple300};
    --alloy-purple-500: ${colors.purple500};
    --alloy-purple-700: ${colors.purple700};
    --alloy-yellow-orange-100: ${colors.yellowOrange100};
    --alloy-yellow-orange-300: ${colors.yellowOrange300};
    --alloy-yellow-orange-500: ${colors.yellowOrange500};
    --alloy-yellow-orange-700: ${colors.yellowOrange700};
    --alloy-green-100: ${colors.green100};
    --alloy-green-300: ${colors.green300};
    --alloy-green-500: ${colors.green500};
    --alloy-green-700: ${colors.green700};
    --alloy-dark-blue-100: ${colors.darkBlue100};
    --alloy-dark-blue-300: ${colors.darkBlue300};
    --alloy-dark-blue-500: ${colors.darkBlue500};
    --alloy-dark-blue-700: ${colors.darkBlue700};
    --alloy-turquoise-100: ${colors.turquoise100};
    --alloy-turquoise-300: ${colors.turquoise300};
    --alloy-turquoise-500: ${colors.turquoise500};
    --alloy-turquoise-700: ${colors.turquoise700};
    --alloy-salmon-300: ${colors.salmon300};
    --alloy-salmon-500: ${colors.salmon500};
    --alloy-salmon-700: ${colors.salmon700};
    --alloy-brown-300: ${colors.brown300};
    --alloy-brown-500: ${colors.brown500};
    --alloy-brown-700: ${colors.brown700};

    --alloy-hover-halo: ${colors.hoverHalo};
    --alloy-active-halo: ${colors.activeHalo};
    --alloy-focus-halo: ${colors.focusHalo};

    --alloy-acs-logo-blue: ${colors.acsLogoBlue};
    --alloy-adsk-blue500-alpha15: ${colors.adskBlue500Alpha15};
    --alloy-adsk-blue300-alpha35: ${colors.adskBlue300Alpha35};
    --alloy-green300-alpha35: ${colors.green300Alpha35};
    --alloy-yellow-orange300-alpha35: ${colors.yellowOrange300Alpha35};
    --alloy-red300-alpha35: ${colors.red300Alpha35};
  }

  /* Atomic Classes */

  /* the alloy namespace makes completions easier and prevents collisions with other utility libraries */
  /* the convention after the alloy namespace follows the Emmet shortcuts */

  /* basing the classes on the css vars requires scoping the target with "alloy-scope" */
  /* this however provides great power to consumers as var overrides will apply to the classes as well */

  /* Colors */
  .alloy-c-adsk-blue-100 { color: var(--alloy-adsk-blue-100); }
  .alloy-c-adsk-blue-300 { color: var(--alloy-adsk-blue-300); }
  .alloy-c-adsk-blue-500 { color: var(--alloy-adsk-blue-500); }
  .alloy-c-adsk-blue-700 { color: var(--alloy-adsk-blue-700); }
  .alloy-c-charcoal-050 { color: var(--alloy-charcoal-050); }
  .alloy-c-charcoal-100 { color: var(--alloy-charcoal-100); }
  .alloy-c-charcoal-200 { color: var(--alloy-charcoal-200); }
  .alloy-c-charcoal-300 { color: var(--alloy-charcoal-300); }
  .alloy-c-charcoal-400 { color: var(--alloy-charcoal-400); }
  .alloy-c-charcoal-500 { color: var(--alloy-charcoal-500); }
  .alloy-c-charcoal-600 { color: var(--alloy-charcoal-600); }
  .alloy-c-charcoal-700 { color: var(--alloy-charcoal-700); }
  .alloy-c-charcoal-800 { color: var(--alloy-charcoal-800); }
  .alloy-c-charcoal-900 { color: var(--alloy-charcoal-900); }
  .alloy-c-black { color: var(--alloy-black); }
  .alloy-c-white { color: var(--alloy-white); }
  .alloy-c-red-100 { color: var(--alloy-red-100); }
  .alloy-c-red-300 { color: var(--alloy-red-300); }
  .alloy-c-red-500 { color: var(--alloy-red-500); }
  .alloy-c-red-700 { color: var(--alloy-red-700); }
  .alloy-c-yellow-orange-100 { color: var(--alloy-yellow-orange-100); }
  .alloy-c-yellow-orange-300 { color: var(--alloy-yellow-orange-300); }
  .alloy-c-yellow-orange-500 { color: var(--alloy-yellow-orange-500); }
  .alloy-c-yellow-orange-700 { color: var(--alloy-yellow-orange-700); }
  .alloy-c-green-100 { color: var(--alloy-green-100); }
  .alloy-c-green-300 { color: var(--alloy-green-300); }
  .alloy-c-green-500 { color: var(--alloy-green-500); }
  .alloy-c-green-700 { color: var(--alloy-green-700); }
  .alloy-c-dark-blue-100 { color: var(--alloy-dark-blue-100); }
  .alloy-c-dark-blue-300 { color: var(--alloy-dark-blue-300); }
  .alloy-c-dark-blue-500 { color: var(--alloy-dark-blue-500); }
  .alloy-c-dark-blue-700 { color: var(--alloy-dark-blue-700); }
  .alloy-c-turquoise-100 { color: var(--alloy-turquoise-100); }
  .alloy-c-turquoise-300 { color: var(--alloy-turquoise-300); }
  .alloy-c-turquoise-500 { color: var(--alloy-turquoise-500); }
  .alloy-c-turquoise-700 { color: var(--alloy-turquoise-700); }
  .alloy-c-purple-300 { color: var(--alloy-purple-300); }
  .alloy-c-purple-500 { color: var(--alloy-purple-500); }
  .alloy-c-purple-700 { color: var(--alloy-purple-700); }
  .alloy-c-pink-300 { color: var(--alloy-pink-300); }
  .alloy-c-pink-500 { color: var(--alloy-pink-500); }
  .alloy-c-pink-700 { color: var(--alloy-pink-700); }
  .alloy-c-salmon-300 { color: var(--alloy-salmon-300); }
  .alloy-c-salmon-500 { color: var(--alloy-salmon-500); }
  .alloy-c-salmon-700 { color: var(--alloy-salmon-700); }
  .alloy-c-brown-300 { color: var(--alloy-brown-300); }
  .alloy-c-brown-500 { color: var(--alloy-brown-500); }
  .alloy-c-brown-700 { color: var(--alloy-brown-700); }

  .alloy-bdc-adsk-blue-100 { border-color: var(--alloy-adsk-blue-100); }
  .alloy-bdc-adsk-blue-300 { border-color: var(--alloy-adsk-blue-300); }
  .alloy-bdc-adsk-blue-500 { border-color: var(--alloy-adsk-blue-500); }
  .alloy-bdc-adsk-blue-700 { border-color: var(--alloy-adsk-blue-700); }
  .alloy-bdc-charcoal-050 { border-color: var(--alloy-charcoal-050); }
  .alloy-bdc-charcoal-100 { border-color: var(--alloy-charcoal-100); }
  .alloy-bdc-charcoal-200 { border-color: var(--alloy-charcoal-200); }
  .alloy-bdc-charcoal-300 { border-color: var(--alloy-charcoal-300); }
  .alloy-bdc-charcoal-400 { border-color: var(--alloy-charcoal-400); }
  .alloy-bdc-charcoal-500 { border-color: var(--alloy-charcoal-500); }
  .alloy-bdc-charcoal-600 { border-color: var(--alloy-charcoal-600); }
  .alloy-bdc-charcoal-700 { border-color: var(--alloy-charcoal-700); }
  .alloy-bdc-charcoal-800 { border-color: var(--alloy-charcoal-800); }
  .alloy-bdc-charcoal-900 { border-color: var(--alloy-charcoal-900); }
  .alloy-bdc-black { border-color: var(--alloy-black); }
  .alloy-bdc-white { border-color: var(--alloy-white); }
  .alloy-bdc-red-100 { border-color: var(--alloy-red-100); }
  .alloy-bdc-red-300 { border-color: var(--alloy-red-300); }
  .alloy-bdc-red-500 { border-color: var(--alloy-red-500); }
  .alloy-bdc-red-700 { border-color: var(--alloy-red-700); }
  .alloy-bdc-yellow-orange-100 { border-color: var(--alloy-yellow-orange-100); }
  .alloy-bdc-yellow-orange-300 { border-color: var(--alloy-yellow-orange-300); }
  .alloy-bdc-yellow-orange-500 { border-color: var(--alloy-yellow-orange-500); }
  .alloy-bdc-yellow-orange-700 { border-color: var(--alloy-yellow-orange-700); }
  .alloy-bdc-green-100 { border-color: var(--alloy-green-100); }
  .alloy-bdc-green-300 { border-color: var(--alloy-green-300); }
  .alloy-bdc-green-500 { border-color: var(--alloy-green-500); }
  .alloy-bdc-green-700 { border-color: var(--alloy-green-700); }
  .alloy-bdc-dark-blue-100 { border-color: var(--alloy-dark-blue-100); }
  .alloy-bdc-dark-blue-300 { border-color: var(--alloy-dark-blue-300); }
  .alloy-bdc-dark-blue-500 { border-color: var(--alloy-dark-blue-500); }
  .alloy-bdc-dark-blue-700 { border-color: var(--alloy-dark-blue-700); }
  .alloy-bdc-turquoise-100 { border-color: var(--alloy-turquoise-100); }
  .alloy-bdc-turquoise-300 { border-color: var(--alloy-turquoise-300); }
  .alloy-bdc-turquoise-500 { border-color: var(--alloy-turquoise-500); }
  .alloy-bdc-turquoise-700 { border-color: var(--alloy-turquoise-700); }
  .alloy-bdc-purple-300 { border-color: var(--alloy-purple-300); }
  .alloy-bdc-purple-500 { border-color: var(--alloy-purple-500); }
  .alloy-bdc-purple-700 { border-color: var(--alloy-purple-700); }
  .alloy-bdc-pink-300 { border-color: var(--alloy-pink-300); }
  .alloy-bdc-pink-500 { border-color: var(--alloy-pink-500); }
  .alloy-bdc-pink-700 { border-color: var(--alloy-pink-700); }
  .alloy-bdc-salmon-300 { border-color: var(--alloy-salmon-300); }
  .alloy-bdc-salmon-500 { border-color: var(--alloy-salmon-500); }
  .alloy-bdc-salmon-700 { border-color: var(--alloy-salmon-700); }
  .alloy-bdc-brown-300 { border-color: var(--alloy-brown-300); }
  .alloy-bdc-brown-500 { border-color: var(--alloy-brown-500); }
  .alloy-bdc-brown-700 { border-color: var(--alloy-brown-700); }

  .alloy-bgc-adsk-blue-100 { background-color: var(--alloy-adsk-blue-100); }
  .alloy-bgc-adsk-blue-300 { background-color: var(--alloy-adsk-blue-300); }
  .alloy-bgc-adsk-blue-500 { background-color: var(--alloy-adsk-blue-500); }
  .alloy-bgc-adsk-blue-700 { background-color: var(--alloy-adsk-blue-700); }
  .alloy-bgc-charcoal-050 { background-color: var(--alloy-charcoal-050); }
  .alloy-bgc-charcoal-100 { background-color: var(--alloy-charcoal-100); }
  .alloy-bgc-charcoal-200 { background-color: var(--alloy-charcoal-200); }
  .alloy-bgc-charcoal-300 { background-color: var(--alloy-charcoal-300); }
  .alloy-bgc-charcoal-400 { background-color: var(--alloy-charcoal-400); }
  .alloy-bgc-charcoal-500 { background-color: var(--alloy-charcoal-500); }
  .alloy-bgc-charcoal-600 { background-color: var(--alloy-charcoal-600); }
  .alloy-bgc-charcoal-700 { background-color: var(--alloy-charcoal-700); }
  .alloy-bgc-charcoal-800 { background-color: var(--alloy-charcoal-800); }
  .alloy-bgc-charcoal-900 { background-color: var(--alloy-charcoal-900); }
  .alloy-bgc-black { background-color: var(--alloy-black); }
  .alloy-bgc-white { background-color: var(--alloy-white); }
  .alloy-bgc-red-100 { background-color: var(--alloy-red-100); }
  .alloy-bgc-red-300 { background-color: var(--alloy-red-300); }
  .alloy-bgc-red-500 { background-color: var(--alloy-red-500); }
  .alloy-bgc-red-700 { background-color: var(--alloy-red-700); }
  .alloy-bgc-yellow-orange-100 { background-color: var(--alloy-yellow-orange-100); }
  .alloy-bgc-yellow-orange-300 { background-color: var(--alloy-yellow-orange-300); }
  .alloy-bgc-yellow-orange-500 { background-color: var(--alloy-yellow-orange-500); }
  .alloy-bgc-yellow-orange-700 { background-color: var(--alloy-yellow-orange-700); }
  .alloy-bgc-green-100 { background-color: var(--alloy-green-100); }
  .alloy-bgc-green-300 { background-color: var(--alloy-green-300); }
  .alloy-bgc-green-500 { background-color: var(--alloy-green-500); }
  .alloy-bgc-green-700 { background-color: var(--alloy-green-700); }
  .alloy-bgc-dark-blue-100 { background-color: var(--alloy-dark-blue-100); }
  .alloy-bgc-dark-blue-300 { background-color: var(--alloy-dark-blue-300); }
  .alloy-bgc-dark-blue-500 { background-color: var(--alloy-dark-blue-500); }
  .alloy-bgc-dark-blue-700 { background-color: var(--alloy-dark-blue-700); }
  .alloy-bgc-turquoise-100 { background-color: var(--alloy-turquoise-100); }
  .alloy-bgc-turquoise-300 { background-color: var(--alloy-turquoise-300); }
  .alloy-bgc-turquoise-500 { background-color: var(--alloy-turquoise-500); }
  .alloy-bgc-turquoise-700 { background-color: var(--alloy-turquoise-700); }
  .alloy-bgc-purple-300 { background-color: var(--alloy-purple-300); }
  .alloy-bgc-purple-500 { background-color: var(--alloy-purple-500); }
  .alloy-bgc-purple-700 { background-color: var(--alloy-purple-700); }
  .alloy-bgc-pink-300 { background-color: var(--alloy-pink-300); }
  .alloy-bgc-pink-500 { background-color: var(--alloy-pink-500); }
  .alloy-bgc-pink-700 { background-color: var(--alloy-pink-700); }
  .alloy-bgc-salmon-300 { background-color: var(--alloy-salmon-300); }
  .alloy-bgc-salmon-500 { background-color: var(--alloy-salmon-500); }
  .alloy-bgc-salmon-700 { background-color: var(--alloy-salmon-700); }
  .alloy-bgc-brown-300 { background-color: var(--alloy-brown-300); }
  .alloy-bgc-brown-500 { background-color: var(--alloy-brown-500); }
  .alloy-bgc-brown-700 { background-color: var(--alloy-brown-700); }

  /* Typography */
  .alloy-type-hero { ${typography.hero} }
  .alloy-type-title { ${typography.title} }
  .alloy-type-heading1 { ${typography.heading1} }
  .alloy-type-heading2 { ${typography.heading2} }
  .alloy-type-heading3 { ${typography.heading3} }
  .alloy-type-heading4 { ${typography.heading4} }
  .alloy-type-heading5 { ${typography.heading5} }
  .alloy-type-body-large { ${typography.bodyLarge} }
  .alloy-type-body-large-bold { ${typography.bodyLargeBold} }
  .alloy-type-body-medium { ${typography.bodyMedium} }
  .alloy-type-body-medium-bold { ${typography.bodyMediumBold} }
  .alloy-type-body-small { ${typography.bodySmall} }
  .alloy-type-body-small-bold { ${typography.bodySmallBold} }
  .alloy-type-label-medium { ${typography.labelMedium} }
  .alloy-type-label-small { ${typography.labelSmall} }
  .alloy-type-caption { ${typography.caption} }
  .alloy-type-caption-bold { ${typography.captionBold} }
  .alloy-type-eyebrow { ${typography.eyebrow} }
  .alloy-type-ellipsis { ${typography.ellipsis} }
  .alloy-type-line-clamp { ${typography.lineClamp} }
`;
